import React from 'react';
import LogoImage from './LogoImage.png';

function Logo() {
  return <img src={LogoImage} alt="Reloved Logo " />;
}

export default Logo;
